export default "__VITE_ASSET__DLhajQ0r__"